<script setup lang="ts">
import ErrorLayout from "@/Pages/errors/layouts/ErrorLayout.vue";
import {computed} from "vue";
import {Head, router} from "@inertiajs/vue3";
import {route} from "ziggy-js";

interface Props {
    status: number,
}

const props = defineProps<Props>()

defineOptions({
    layout: ErrorLayout
})

const description = computed(() => {
    switch (props.status.toString()) {
    case '403':
        return 'Sorry, you are forbidden from accessing this page.'
    case '404':
        return 'Sorry, the page you are looking for could not be found.'
    case '500':
        return 'Sorry, something went wrong on the server.'
    case '503':
        return 'Sorry, the server is temporarily unavailable.'
    default:
        return 'Sorry, something went wrong.'
    }
})
</script>

<template>
    <Head title="Error" />
    <v-row class="fill-height">
        <v-col
            cols="12"
            md="6"
            class="py-0 align-self-center px-15"
        >
            <h1 class="text-h1 font-weight-medium">
                {{ props.status }}
            </h1>
            <v-divider
                class="my-5"
                thickness="5"
                color="primary"
                length="50"
            />
            <div class="text-h4 font-weight-light text-grey-darken-2">
                {{ description }}
            </div>
            <default-btn
                class="mt-10"
                @click="router.visit(route('dashboard'))"
            >
                Go back
            </default-btn>
        </v-col>
        <v-col
            cols="12"
            md="6"
            class="pa-0 fill-height img-background d-none d-md-flex"
            :class="`error-${props.status}`"
        />
    </v-row>
</template>

<style scoped>
.img-background {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center right;
}

.error-500 {
    background-image: url(@/assets/500.svg);
}

.error-503 {
    background-image: url(@/assets/503.svg);
}

.error-404 {
    background-image: url(@/assets/404.svg);
}

.error-403 {
    background-image: url(@/assets/403.svg);
}
</style>
